<template>
  <div class="flex flex-col gap-2">
    <template v-if="negationEnabled">
      <InfuseNegatableFilter
        :model-value="negated"
        @update:model-value="(newValue) => valuesChanged(selectedOption, newValue)"
      >
        <InfuseSelect
          :model-value="selectedOption"
          name="select-filter"
          size="small"
          :options="options"
          required
          @update:model-value="(newValue) => valuesChanged(newValue, negated)"
        />
      </InfuseNegatableFilter>
    </template>
    <template v-else>
      <InfuseSelect
        :model-value="selectedOption"
        name="select-filter"
        size="small"
        :options="options"
        required
        @update:model-value="(newValue) => valuesChanged(newValue, false)"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { FilterOption } from '@infuse/ui/domain';
import { computed, onMounted, Ref, ref } from 'vue';
import { InfuseNegatableFilter, InfuseSelect } from '../../index';

interface Props {
  modelValue: FilterOption[];
  negationEnabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  negationEnabled: true
});

interface Emits {
  (e: 'apply:value', value: FilterOption, negated: boolean): void;

  (e: 'validationChange', valid: boolean): void;
}

const emit = defineEmits<Emits>();

const options = computed(() =>
  props.modelValue.map((fo) => {
    return { key: fo.label(), value: fo.name, name: fo.name };
  })
);

const selectedOption: Ref<string> = ref('');
const negated = ref(false);

onMounted(() => {
  const defaultOption = props.modelValue[0];
  selectedOption.value = defaultOption?.name ?? '';

  valuesChanged(selectedOption.value, props.negationEnabled ? negated.value : false);
});

function valuesChanged(newValue: string, newNegated: boolean): void {
  selectedOption.value = newValue;
  negated.value = props.negationEnabled ? newNegated : false;
  const option = props.modelValue.find((o) => o.name === selectedOption.value);

  if (option) {
    emit('apply:value', option, negated.value);
    emit('validationChange', !!selectedOption.value);
  }
}
</script>
